import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "gray" }, null, -1)
const _hoisted_2 = {
  class: "inputError",
  style: {"color":"red","font-size":"small"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProviderItem = _resolveComponent("ProviderItem")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("connected_accounts.choose_provider")), 1),
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: _ctx.$t(`connected_accounts.providers`)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providers.data, (provider, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                _createVNode(_component_ProviderItem, {
                  onClick: ($event: any) => (_ctx.selectedProvider = provider),
                  onKeypress: _withKeys(($event: any) => (_ctx.selectedProvider = provider), ["enter"]),
                  class: _normalizeClass({ active: provider === _ctx.selectedProvider }),
                  provider: provider,
                  tabindex: "0"
                }, null, 8, ["onClick", "onKeypress", "class", "provider"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }),
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.error), 1),
    _createVNode(_component_Button, {
      "event-name": "connectPaymentProviderButton",
      "event-from": "/user/related-accounts/add",
      label: _ctx.$t(`connected_accounts.continue`),
      class: "defaultButton",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendProvider())),
      tabindex: "0"
    }, null, 8, ["label"]),
    _createVNode(_component_router_link, {
      to: { name: 'RelatedAccounts' },
      class: "cancel"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
      ]),
      _: 1
    })
  ], 64))
}